import React from 'react';
import { apiCall } from '../common/common';
import { displayLog } from '../common/common';

//config
import config from "../config";

const PagesContext = React.createContext();


const rootReducer = (state, action) => {
  switch (action.type) {

    case "SETPrivacypolicy":
      return {
        isLoaded: true,
        privacypolicy: action.payload,
      };

    case "GETPrivacypolicy":
      return {
        isLoaded: true,
        privacyData: action.payload,
      };

    case "GETHelp":
      return {
        isLoaded: true,
        getHelp: action.payload,
      };

    case "SETHelp":
      return {
        isLoaded: true,
        setHelp: action.payload,
      };

    case "Terms":
      return {
        isLoaded: true,
        Terms: action.payload,
      };

    case "EditTerms":
      return {
        isLoaded: true,
        TermsEdit: action.payload,
      };

    // case "GETFeedback":
    //   return {
    //     isLoaded: true,
    //     feedBack : action.payload,
    //   };

    default:
      return {
        ...state
      };
  }
};

const PagesProvider = ({ children }) => {

  //set privacypolicyd content
  const [privacypolicy, setprivacypolicy] = React.useReducer(rootReducer, {
    isLoaded: false,
    privacypolicy: []
  });

  //get privacypolicy content
  const [privacyData, setprivacyData] = React.useReducer(rootReducer, {
    isLoaded: false,
    privacyData: []
  });

  // set help content
  const [Helpcontent, setHelpcontent] = React.useReducer(rootReducer, {
    isLoaded: false,
    setHelp: []
  });

  //get help content
  const [Gethelpcontent, setGetContent] = React.useReducer(rootReducer, {
    isLoaded: false,
    getHelp: []
  });


  //get Terms_and_condition content
  const [Terms, setTerms] = React.useReducer(rootReducer, {
    isLoaded: false,
    Terms: []
  });

  //set terms_and_condition content
  const [TermsEdit, setTermsEdit] = React.useReducer(rootReducer, {
    isLoaded: false,
    TermsEdit: []
  });


  //get feedback content
  //  const [feedBack, setfeedback] = React.useReducer(rootReducer, {
  //   isLoaded: false,
  //   feedBack: []
  // });

  return (
    <PagesContext.Provider value={{
      privacypolicy, setprivacypolicy,
      privacyData, setprivacyData,
      Gethelpcontent, setGetContent,
      Helpcontent, setHelpcontent,
      Terms, setTerms,
      TermsEdit, setTermsEdit
      //feedBack,setfeedback
    }}>
      {children}
    </PagesContext.Provider>
  );
};

const usePagesState = () => {
  const context = React.useContext(PagesContext);
  return context;
};

//API call to set Privacy Policy content 
export const setPrivacyPolicy = async (dispatch, reqData) => {
  let res = await apiCall('POST', 'SETPrivacypolicy', '/admin/editPageContent', reqData, {}, {}, dispatch)
  if (res.data) {
    if (res.data.code === 0) {
      displayLog(0, res.data.message)
    } else {
      dispatch({ type: "SETPrivacypolicy", payload: res.data });
      displayLog(1, res.data.message)
    }
  }
}

//API call to get Privacy Policy content 
export const GetPrivacyPolicy = async (dispatch, reqData) => {
  let res = await apiCall('GET', 'GETPrivacypolicy', '/admin/privacyPolicy', reqData, {
    'auth_token': config.defaultAuthToken
  }, {}, dispatch)
  if (res && res.data) {
    if (res.data.code === 0) {
      displayLog(0, res.data.message)
    } else {
      dispatch({ type: "GETPrivacypolicy", payload: res.data });
      // displayLog(1, res.data.message)
    }
  }
}

//API call to get Help content 
export const GetHelpContent = async (dispatch, reqData) => {
  let res = await apiCall('GET', 'GETHelp', '/admin/help', reqData, {
    'auth_token': config.defaultAuthToken
  }, {}, dispatch)
  if (res && res.data) {
    if (res.data.code === 0) {
      displayLog(0, res.data.message)
    } else {
      dispatch({ type: "GETHelp", payload: res.data });
      // displayLog(1, res.data.message)
    }
  }
}

//API call to set Help content 
export const SetHelpContent = async (dispatch, reqData) => {
  let res = await apiCall('POST', 'SETHelp', '/admin/editPageContent', reqData, {}, {}, dispatch)
  if (res && res.data) {
    if (res.data.code === 0) {
      displayLog(0, res.data.message)
    } else {
      dispatch({ type: "SETHelp", payload: res.data });
      displayLog(1, res.data.message)
    }
  }
}

//API call to get Terms content 
export const TermsAndcondition = async (dispatch, reqData) => {
  let res = await apiCall('GET', 'Terms', '/admin/termsConditions', reqData, {
    'auth_token': config.defaultAuthToken
  }, {}, dispatch)
  if (res && res.data) {
    if (res.data.code === 0) {
      displayLog(0, res.data.message)
    } else {
      dispatch({ type: "Terms", payload: res.data });
      // displayLog(1, res.data.message)
    }
  }
}

//API call to set Terms content 
export const TermsEdit = async (dispatch, reqData) => {
  let res = await apiCall('POST', 'EditTerms', '/admin/editPageContent', reqData, {}, {}, dispatch)
  if (res && res.data) {
    if (res.data.code === 0) {
      displayLog(0, res.data.message)
    } else {
      displayLog(1, res.data.message)
      dispatch({ type: "EditTerms", payload: res.data });
    }
  }
}



// //API call to set Help content 
// export const getfeedback = async (dispatch, reqData) => {
//   let res = await apiCall('GET', 'GETFeedback', '/admin/getFeedbackList', reqData, {}, {},dispatch)
//   if (res && res.data) {
//     if (res.data.code === 0) {
//       displayLog(0, res.data.message)
//     } else {
//       dispatch({ type: "GETFeedback", payload: res.data });
//       // displayLog(1, res.data.message)
//     }
//   }
// }



export { PagesProvider, PagesContext, usePagesState };
